import {
  initialState,
  Actions,
  State,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_ERROR,
  RESET_EDIT_USER
} from '../../types/user/edit'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case EDIT_USER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case EDIT_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case EDIT_USER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    case RESET_EDIT_USER:
      return initialState
    default:
      return state
  }
}

export default reducers
